import * as React from 'react';

import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';

export default function Step5({ templateData, setTemplateData }) {
  return (
    <Stack
      spacing={4}
      sx={{
        maxWidth: '700px',
        marginLeft: 'auto',
        marginRight: '25px',
      }}
    >
      <TextField
        id="outlined-controlled"
        label="CTA 1 Name"
        value={templateData.cta_1_title}
        onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
          setTemplateData({
            ...templateData,
            cta_1_title: event.target.value,
          });
        }}
      />
      <TextField
        id="outlined-controlled"
        label="CTA 1 URL"
        value={templateData.cta_1_url}
        onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
          setTemplateData({
            ...templateData,
            cta_1_url: event.target.value,
          });
        }}
      />
      <TextField
        id="outlined-controlled"
        label="CTA 2 Name"
        value={templateData.cta_2_title}
        onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
          setTemplateData({
            ...templateData,
            cta_2_title: event.target.value,
          });
        }}
      />
      <TextField
        id="outlined-controlled"
        label="CTA 2 URL"
        value={templateData.cta_2_url}
        onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
          setTemplateData({
            ...templateData,
            cta_2_url: event.target.value,
          });
        }}
      />
      <TextField
        id="outlined-controlled"
        label="CTA 3 Name"
        value={templateData.cta_3_title}
        onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
          <Button variant="contained">Generate Email</Button>;
          setTemplateData({
            ...templateData,
            cta_3_title: event.target.value,
          });
        }}
      />
      <TextField
        id="outlined-controlled"
        label="CTA 3 URL"
        value={templateData.cta_3_url}
        onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
          setTemplateData({
            ...templateData,
            cta_3_url: event.target.value,
          });
        }}
      />
    </Stack>
  );
}
